// The intent of this component is to make a workaround for the following issue:
// https://github.com/ionic-team/ionic-framework/issues/20106
import { IonSelect, SelectChangeEventDetail } from '@ionic/react';
import { useCallback, useRef } from 'react';

type IonSelectProps = React.ComponentPropsWithoutRef<typeof IonSelect>;
type CustomIonSelectProps = IonSelectProps & {
    onIonChange?: (e: CustomEvent<SelectChangeEventDetail>) => void;
};
const CustomIonSelect: React.FC<CustomIonSelectProps> = ({
    children,
    onIonChange,
    ...rest
}) => {
    const hasEmittedValue = useRef(false);

    const onChangeHandler = useCallback(
        (e: CustomEvent<SelectChangeEventDetail>) => {
            if (!hasEmittedValue.current) {
                hasEmittedValue.current = true;
                onIonChange && onIonChange(e);
            }
            setTimeout(() => (hasEmittedValue.current = false), 0);
        },
        [onIonChange]
    );

    return (
        <IonSelect {...rest} onIonChange={onChangeHandler}>
            {children}
        </IonSelect>
    );
};

export default CustomIonSelect;
